<template>
  <div v-if="acessoPermitido" class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <div v-if="tela == 1">
            <!--Campo de Datas-->
            <div class="col-sm-12 text-left mt-1 row">
              <base-input class="col-sm-4 col-12 text-left" label="Data Inicial" type="date" v-model="data_inicial">
              </base-input>

              <base-input class="col-sm-4 col-12 text-left" label="Data Final" type="date" v-model="data_final">
              </base-input>

              <!--Buttons-->
              <div class="col-sm-3 col-12 mt-2">
                <base-button native-type="submit" type="success" size="lg" block @click="listarAssinaturas()">
                  Pesquisar
                </base-button>
              </div>

            </div>
            <h4 slot="header" class="card-title text-left">Assinaturas de Ponto</h4>
            <div>
              <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
                <div>
                  <el-select class="select-success mb-3 pagination-select" v-model="pagination.perPage"
                    placeholder="Per page">
                    <el-option class="select-success" v-for="item in pagination.perPageOptions" :key="item"
                      :label="item" :value="item">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <el-table :data="queriedData">
                <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth"
                  :prop="column.prop" :label="column.label">
                </el-table-column>
                <el-table-column :min-width="100" align="right" label="Ações">
                  <div slot-scope="props">
                    <el-tooltip v-if="props.row.status == 'Pendente'" content="Aceitar Assinatura" effect="light"
                      :open-delay="300" placement="top">
                      <base-button @click.native="
                        aceitarAssinatura(props.$index, props.row)
                        " class="edit btn-link" type="info" size="sm" icon>
                        <i class="tim-icons icon-check-2"></i>
                      </base-button>
                    </el-tooltip>

                    <el-tooltip
                      v-if="props.row.status == 'Pendente' || (props.row.status == 'Aceito' && props.row.hashAssinatura)"
                      content="Visualizar Assinatura" effect="light" :open-delay="300" placement="top">
                      <base-button @click.native="
                        selecionarAssinatura(props.$index, props.row)
                        " class="edit btn-link" type="info" size="sm" icon>
                        <i class="tim-icons icon-notes"></i>
                      </base-button>
                    </el-tooltip>
                  </div>
                </el-table-column>
              </el-table>
            </div>
            <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
              <div class="">
                <p class="card-category">
                  Mostrando de {{ from + 1 }} a {{ to }} no total de
                  {{ total }} assinaturas.
                </p>
              </div>
              <base-pagination class="pagination-no-border" v-model="pagination.currentPage"
                :per-page="pagination.perPage" :total="total">
              </base-pagination>
            </div>
          </div>
          <!--Tela de detalhes-->
          <div v-if="tela == 2">
            <h4 slot="header" class="card-title text-left">Detalhes da Assinatura</h4>
            <div class="row m-0 p-0">
              <div class="col-md-9 p-2 text-left">
                <base-input label="Nome" type="tel" readonly v-model="assinaturaSelecionado.nome">
                </base-input>
              </div>
              <div class="col-md-3 p-2 text-left">
                <base-input label="Status" type="tel" readonly v-model="assinaturaSelecionado.status">
                </base-input>
              </div>
            </div>
            <div class="row m-0 p-0">
              <div class="col-md-3 p-2 text-left">
                <base-input label="Data Inicial" type="tel" readonly v-model="assinaturaSelecionado.dataInicial">
                </base-input>
              </div>
              <div class="col-md-3 p-2 text-left">
                <base-input label="Data Final" type="tel" readonly v-model="assinaturaSelecionado.dataFinal">
                </base-input>
              </div>
              <div class="col-md-3 p-2 text-left">
                <base-input label="Data Geração" type="tel" readonly v-model="assinaturaSelecionado.dataGeracao">
                </base-input>
              </div>
              <div class="col-md-3 p-2 text-left">
                <base-input label="Data Assinatura" type="tel" readonly v-model="assinaturaSelecionado.dataAssinatura">
                </base-input>
              </div>
            </div>
            <div class="row m-0 p-0">
              <div class="col-md-6 p-2 text-left">
                <base-input label="Hash Assinatura" type="tel" readonly v-model="assinaturaSelecionado.hashAssinatura">
                </base-input>
              </div>
              <div class="col-md-6 p-2 text-left">
                <base-input label="Ip" type="tel" readonly v-model="assinaturaSelecionado.ip">
                </base-input>
              </div>
            </div>

            <div class="row m-0 p-0 pb-4">
              <div class="col-md-12 p-0 text-left">
                <button type="button" class="btn btn-link" @click="abrirPdf(assinaturaSelecionado.arquivoOriginal)">
                  <i class="tim-icons icon-attach-87"></i> Click aqui para ver o
                  documento original</button>
              </div>
              <div class="col-md-12 p-0 text-left" v-if="assinaturaSelecionado.arquivoAssinado">
                <button type="button" @click="abrirPdf(assinaturaSelecionado.arquivoAssinado)" class="btn btn-link">
                  <i class="tim-icons icon-attach-87"></i> Click aqui para ver o
                  documento assinado</button>
              </div>

            </div>
            <base-button type="danger" class="d-flex justify-content-start"
              @click="fecharVisualizacao()">Fechar</base-button>

          </div>
        </card>
      </div>
    </div>

    <div class="vld-parent">
      <loading :active.sync="isLoading" :can-cancel="false" loader="spinner" color="#35a887" :is-full-page="true">
      </loading>
    </div>
    <modal v-if="showRecFacial" :show.sync="showRecFacial">
      <modal-rec-facial-2 width="80%" height="80%" />
    </modal>
  </div>
  <div v-else-if="!acessoPermitido && !pageErro" class="content small">
    <modal v-if="showRecFacialInitial" :show.sync="showRecFacialInitial">
      <modal-rec-facial-2 width="80%" height="80%" />
    </modal>
  </div>
  <div v-else-if="pageErro" class="content small">
    <div class="flex flex-col items-center justify-center h-full">
      <h1 class="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
        Acesso Negado
      </h1>
      <p class="text-gray-600 text-center">
        Você não tem permissão para acessar esta página.
      </p>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import ModalRecFacial2 from "../../src/pages/Components/ModalRecFacial2.vue";
import Modal from "@/components/Modal.vue";
import moment from 'moment';
import {
  Card,
  BasePagination,
  BaseInput,
  ImageUpload,
} from "@/components/index";
import {
  Table,
  TableColumn,
  Select,
  Option,
  TimeSelect,
  DatePicker,
} from "element-ui";
import swal from "sweetalert2";
import Fuse from "fuse.js";

export default {
  components: {
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    ImageUpload,
    ModalRecFacial2,
    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    BasePagination,
    BaseInput,
    Modal,
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      tela: 1,
      showRecFacial: false,
      assinaturaSelecionado: "",
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10],
        total: 0,
      },
      isLoading: false,
      searchQuery: "",
      tableColumns: [
        {
          prop: "nome",
          label: "Nome",
          minWidth: 250,
        },
        {
          prop: "dataInicial",
          label: "Início",
          minWidth: 100,
        },
        {
          prop: "dataFinal",
          label: "Fim",
          minWidth: 100,
        },
        {
          prop: "status",
          label: "Status",
          minWidth: 100,
        },
        {
          prop: "dataGeracao",
          label: "Data Geração",
          minWidth: 100,
        },
        {
          prop: "dataAssinatura",
          label: "Data Assinatura",
          minWidth: 100,
        },
      ],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      dados: "",
      ip: "",
      data_inicial: "",
      data_final: "",
      showRecFacialInitial: true,
      acessoPermitido: false,
      pageErro: false
    };
  },
  mounted() {
    this.data_inicial = new Date(new Date().getFullYear(), 0, 1).toISOString().slice(0, 10)
    this.data_final = new Date(new Date().getFullYear(), 11, 31).toISOString().slice(0, 10)
    this.getIp();
    this.listarAssinaturas();
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["dataInicial", "dataFinal", "status"],
      threshold: 0.3,
    });

    this.$root.$on("checkFacial", (data) => {
      if (data) {
        this.showRecFacial = false;
        this.acessoPermitido && this.solicitarAceite();
      }
    });

    this.$root.$on("checkFacial", data => {
      try {
        if (data) {
          this.showRecFacialInitial = false;
          this.acessoPermitido = true;
          this.pageErro = false; // Garante que a tela de erro não apareça
        } else {
          this.showRecFacialInitial = false; // Fecha a modal de reconhecimento facial
          this.acessoPermitido = false; // Bloqueia o acesso
          this.pageErro = true; // Mostra a tela de acesso negado
        }
      } catch {
        this.showRecFacialInitial = false;
        this.acessoPermitido = false;
        this.pageErro = true;
      }
    });
  },
  methods: {
    carregarDados() {
      this.dados = JSON.parse(this.$session.get("dados"));
      console.log(this.dados)
    },
    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },
    getIp() {
      const th = this
      this.axios
        .get("https://api.ipify.org/")
        .then((response) => {
          console.log(response.data)
          th.ip = response.data
        })
        .catch((err) => {
          console.log(err)
        });
    },
    async selecionarAssinatura(index, row) {
      this.assinaturaSelecionado = row;
      this.tela = 2;
      await this.listarDocumentos()
    },

    async solicitarAceite() {
      let th = this;
      th.isLoading = true;

      if (!this.ip) {
        await this.getIp()
      }

      const bodyFormData = {
        setDB: this.dados.DB_NAME,
        id: this.assinaturaSelecionado.id,
        ip: this.ip
      };
      this.axios
        .post("/api/assinaturasPonto/aceitar", bodyFormData)
        .then((response) => {
          th.isLoading = false;
          if (response.data.status == "success") {
            th.showSwal(
              "auto-close",
              "Sucesso",
              "Sua solicitação foi realizada com sucesso! Seu comprovante será liberado em instantes",
              "success"
            );
            th.listarAssinaturas();

          } else {
            th.showSwal("auto-close", "Erro", "Erro ao solicitar assinatura!", "error");
          }
        })
        .catch((err) => {
          console.log(err)
          th.isLoading = false;
          th.showSwal("auto-close", "Erro", "Erro ao solicitar assinatura!", "error");
        });

    },

    aceitarAssinatura(index, row) {
      this.assinaturaSelecionado = row;
      this.showRecFacial = true;

    },
    listarAssinaturas() {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.dados.DB_NAME,
        id_funcionario: this.dados.ID_EMPREGADO,
        data_inicial: this.data_inicial,
        data_final: this.data_final,
      };

      this.axios
        .post(
          "/api/assinaturasPonto/listarAssinaturasPorFuncionario",
          bodyFormData
        )
        .then((response) => {
          th.isLoading = false;

          th.tableData = response.data.data
        })
        .catch((err) => {
          th.isLoading = false;
          th.showSwal("auto-close", "Erro", "Erro ao listar!", "error");
        });
    },
    listarDocumentos() {
      let th = this;
      this.isLoading = true;

      const bodyFormData = {
        setDB: this.dados.DB_NAME,
        id: this.assinaturaSelecionado.id
      };

      this.axios
        .post(
          "/api/assinaturasPonto/listarDocumentosPorFuncionario",
          bodyFormData
        )
        .then((response) => {
          th.isLoading = false;

          if (response.data.data) {
            const dados = response.data.data
            th.assinaturaSelecionado = {
              ...th.assinaturaSelecionado,
              arquivoAssinado: dados.arquivoAssinado,
              arquivoOriginal: dados.arquivoOriginal
            }
          }
        })
        .catch((err) => {
          th.isLoading = false;
          th.showSwal("auto-close", "Erro", "Erro ao listar documentos!", "error");
        });
    },
    fecharVisualizacao() {
      this.assinaturaSelecionado = "";
      this.tela = 1;
    },
    base64ToArrayBuffer(data) {
      var bString = window.atob(data);
      var bLength = bString.length;
      var bytes = new Uint8Array(bLength);
      for (var i = 0; i < bLength; i++) {
        var ascii = bString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    abrirPdf(data) {
      var bufferArray = this.base64ToArrayBuffer(data);
      var blobStore = new Blob([bufferArray], { type: "application/pdf" });
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blobStore);
        return;
      }
      var data = window.URL.createObjectURL(blobStore);
      var link = document.createElement('a');
      document.body.appendChild(link);
      link.href = data;
      link.download = "file.pdf";
      link.click();
      window.URL.revokeObjectURL(data);
      link.remove();
    },
  },

  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  },
  created() {
    this.carregarDados();
  },
};
</script>
<style>
.divCorpoDialog {
  padding: 0px;
  margin-top: -25px;
}
</style>
